import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import LinkedIn from "@iconscout/react-unicons/icons/uil-linkedin";
import Gmail from "@iconscout/react-unicons/icons/uil-envelope";
import Github from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>AddyGeneral Technologies</span>
        <div className="f-icons">
        <a href="https://www.linkedin.com/in/joel-obuamah-addy-723043153/">
            <LinkedIn color="white" size={"3rem"} />
          </a>
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=addyojoel@gmail.com">
            <Gmail color="white" size={"3rem"} />
          </a>
          <a href="https://github.com/addygeneral">
            <Github color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
